/* eslint-disable no-param-reassign */
import { useLocalStorageState } from 'ahooks';
import { useEffect } from 'react';
import { useImmer } from 'use-immer';
import { getNumberParamFromUrl } from '@/infrastructure/history';

import { PAGE_SIZES } from '@/presentation/components/issue-list/utils';
export interface PaginationValue {
  start: number;
  rows: number;
  pageSize: number;
  current: number;
}

export const initPageSetting = {
  current: 1,
  pageSize: 10,
};

export function usePagination(pageId: string): [PaginationValue, (current: number, pageSize: number) => void] {
  const initStart = getNumberParamFromUrl('start');
  const initRows = getNumberParamFromUrl('rows', 10);
  const initCurrent = (Math.floor(initStart / initRows)) + 1;
  const [localPageSize, setLocalPageSize] = useLocalStorageState<number | undefined>(
    `table-page-size-${pageId}`,
    {
      defaultValue: initPageSetting.pageSize,
    },
  );
  const [pagination, updatePagination] = useImmer<PaginationValue>({
    start: initStart,
    rows: localPageSize && PAGE_SIZES.includes(localPageSize) ? localPageSize :  initRows,
    current: initCurrent,
    pageSize: localPageSize && PAGE_SIZES.includes(localPageSize) ? localPageSize :  initRows,
  });

  const handlePaginationUpdate = (current: number, pageSize: number) => {
    const start = (current - 1) * pageSize;
    setLocalPageSize(pageSize);
    updatePagination((draft) => {
      draft.start = start;
      draft.rows = pageSize;
      draft.current = current;
      draft.pageSize = pageSize;
    });

    // redirectToNewSearchParams({
    //   start,
    //   rows: pageSize,
    // });
  };

  useEffect(() => {
    const current = (Math.floor(initStart / initRows)) + 1;
    updatePagination((draft) => {
      draft.start = initStart;
      draft.rows = localPageSize && PAGE_SIZES.includes(localPageSize) ? localPageSize :  initRows;
      draft.current = current;
      draft.pageSize = localPageSize && PAGE_SIZES.includes(localPageSize) ? localPageSize :  initRows;
    });
  }, [initRows, initStart]);

  return [pagination, handlePaginationUpdate];
}
